/**
 * Get default SEO description from leadText or title
 * @author Jan Alexander (jan.alexander@valiton.com)
 * @author Patrik Vodicka (patrik.vodicka.ext@burda-forward.de)
 * @originalCommit a76239182a0 (2024-05-21)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
export const getDefaultSeoDescription = (entity) => {
    if (entity.leadText?.trim()) {
        return entity.leadText;
    }
    return entity.title;
};
/**
 * Check if entity has a custom SEO description
 * @author Jan Alexander (jan.alexander@valiton.com)
 * @author Patrik Vodicka (patrik.vodicka.ext@burda-forward.de)
 * @originalCommit a76239182a0 (2024-05-21)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
export const hasCustomSeoDescription = (entity) => entity && entity.seoDescription ? !!entity.seoDescription.trim() && entity.seoDescription !== getDefaultSeoDescription(entity) : false;
/**
 * Update SEO description with default value if not custom
 * @author Jan Alexander (jan.alexander@valiton.com)
 * @originalCommit a76239182a0 (2024-05-21)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
export const updateDefaultSeoDescription = (entity, previousEntity) => {
    if (!hasCustomSeoDescription(entity) ||
        (previousEntity && !hasCustomSeoDescription(previousEntity) && previousEntity.seoDescription === entity.seoDescription)) {
        entity.seoDescription = getDefaultSeoDescription(entity);
    }
};
/**
 * Check if entity has a custom SEO title
 * @author Felice Sallustio (felice.sallustio@burda-forward.de)
 * @originalCommit dccf1364a55 (2025-06-09)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
const _hasCustomSeoTitle = (entity) => entity && !!entity.seoTitle.trim() && entity.seoTitle !== entity.title;
/**
 * Check if entity is in draft state
 * @author Nicola Scarpelli (nicola.scarpelli@burda-forward.de)
 * @originalCommit d160f7727b5 (2025-09-18)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
const _isEntityInDraft = (entityState) => entityState === 'draft';
/**
 * Update SEO title with default value (title) if not custom and in draft state
 * @author Felice Sallustio (felice.sallustio@burda-forward.de) - CTF-5949
 * @author Nicola Scarpelli (nicola.scarpelli@burda-forward.de) - CTF-6200
 * @originalCommit d160f7727b5 (2025-09-18)
 * @originalFile modules/news-article/utils/src/defaults/seo.defaults.ts
 *
 * Note: Use `git blamec` to see original authorship in git history
 */
export const updateDefaultSeoTitle = (entity, previousEntity) => {
    if (_isEntityInDraft(entity.state) &&
        (!_hasCustomSeoTitle(entity) || (previousEntity && !_hasCustomSeoTitle(previousEntity) && previousEntity.seoTitle === entity.seoTitle))) {
        entity.seoTitle = entity.title;
    }
};
//# sourceMappingURL=seo.defaults.js.map